import { SVGProps } from 'react';

import { COLORS } from '../../../theme/colors';
import { styleConfigs } from '../../resources/styleConfigs';

interface ICheckCircleOutlinedIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  color?: string;
}

const CheckCircleOutlinedIcon = ({
  width = styleConfigs.dimensions.width22,
  height = styleConfigs.dimensions.height22,
  color = COLORS.white,
  ...props
}: ICheckCircleOutlinedIconProps): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.2077 6.94703L9.16683 12.9879L5.876 9.7062L4.5835 10.9987L9.16683 15.582L16.5002 8.2487L15.2077 6.94703ZM11.0002 1.83203C5.94016 1.83203 1.8335 5.9387 1.8335 10.9987C1.8335 16.0587 5.94016 20.1654 11.0002 20.1654C16.0602 20.1654 20.1668 16.0587 20.1668 10.9987C20.1668 5.9387 16.0602 1.83203 11.0002 1.83203ZM11.0002 18.332C6.9485 18.332 3.66683 15.0504 3.66683 10.9987C3.66683 6.94703 6.9485 3.66536 11.0002 3.66536C15.0518 3.66536 18.3335 6.94703 18.3335 10.9987C18.3335 15.0504 15.0518 18.332 11.0002 18.332Z"
      fill={color}
    />
  </svg>
);

export default CheckCircleOutlinedIcon;
